import { useState } from 'react';

export function useLoading<T extends (...args: any[]) => Promise<any>>(
  callback: T,
): [(...args: Parameters<T>) => Promise<void>, boolean] {
  const [loading, setLoading] = useState<boolean>(false);

  const execute = async (...args: Parameters<T>): Promise<void> => {
    try {
      await callback(...args);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return [execute, loading];
}
